// extracted by mini-css-extract-plugin
export default {"respondentPanel":"respondentPanel___d9575c2d12555bcbde0b","bold":"bold___fb8f414b0b8d49d3727d"};